import { Label } from '@/components/ui/label';
import useLogin from './uesLogin';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import { Switch } from '@/components/ui/switch';
import { Link } from 'react-router-dom';
import Container from '@/components/Container';
import Loading from './loading.skeleton';
import FieldError from '@/components/FieldError';

export default function Login() {
  const { handleSubmit, register, loginPage, isConfirmation, setValue, errors } = useLogin();

  const renderHeaderMessages = () => {
    if (isConfirmation) {
      return (
        <>
          <p className=" mb-2 text-sh-md font-bold">{loginPage?.confirmEmailTitle}</p>{' '}
          <p className=" mb-8 text-sh-sm">{loginPage?.pleaseLoginTItle}</p>
        </>
      );
    }

    return (
      <h2 className="mb-8 text-center text-2xl font-medium leading-9 tracking-tight text-gray-900">
        {loginPage?.loginTitle}
      </h2>
    );
  };

  if (!loginPage) return <Loading />;

  return (
    <Container className="h-full">
      <div className="col-span-12 flex items-center justify-center">
        <div
          className="flex max-h-[90vh]  w-full max-w-[430px] flex-col items-start overflow-auto rounded-2xl bg-white p-8"
          style={{ boxShadow: '0px 0px 20px 0px #86AAD5' }}>
          <img
            className="mb-11 h-auto w-[56%]"
            src={loginPage?.logo.data?.attributes?.url}
            alt={loginPage?.logo.data?.attributes?.alternativeText || 'Logo'}
          />
          {renderHeaderMessages()}

          <form className="flex w-full flex-col items-start" onSubmit={handleSubmit}>
            <div className="mb-5 w-full">
              <Label>
                <p className="mb-2 text-sh-xs">{loginPage?.yourEmailTitle}</p>
              </Label>
              <Input placeholder={loginPage?.yourEmailTitle} type="email" {...register('identifier')} />
              <FieldError message={errors?.identifier?.message} />
            </div>

            <div className="mb-9 w-full">
              <Label>
                <p className="mb-2 text-sh-xs">{loginPage?.yourPasswordTitle}</p>
              </Label>
              <Input placeholder={loginPage?.yourPasswordTitle} type="password" {...register('password')} />
              <FieldError message={errors?.password?.message} />
            </div>

            <div className="mb-8 flex items-center space-x-2">
              <Switch
                id="rememberMe"
                name="rememberMe"
                onCheckedChange={(value) => {
                  setValue('rememberMe', value);
                }}
              />
              <h1 className="text-sh-xs font-medium ">{loginPage?.rememberMeTitle}</h1>
            </div>

            <Button type="submit" theme="solid" className=" mb-4">
              {loginPage?.loginCta}
            </Button>
          </form>
          <a className="text-center text-sh-xs font-medium text-[#1775E3]" href="/reset-password">
            {loginPage?.forgotYourPasswordCta}
          </a>

          <p className="mt-4 text-sh-xs font-normal">
            Don&apos;t have a login?{'  '}
            <Link className="text-center text-sh-xs font-medium text-[#1775E3]" to="/register">
              Register here
            </Link>
          </p>
        </div>
      </div>
    </Container>
  );
}
